// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Vm","menu":"i_Vn","items":"i_Vo","item":"i_Vp","value":"i_Vq","focused":"i_Vr","icon":"i_Vs"};